import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'
import { useDocumentTitle } from '@/hooks/document-title'
import { useActivation } from '@/hooks/view-model-hooks'
import { useScrollOffsets } from '@/hooks/element-hooks'
import { isRefreshDesign } from '@/infra/design'
import { UserManagement } from '@/features/user-management/UserManagement'
import { UserManagementTableContainer } from '@/features/user-management/components/UserManagementTable/UserManagementTableContainer'
import { UserListContainer } from '@/features/user-management/components/UserListContainer'
import { UserManagementWorkspaceSwitcherContainer } from '@/features/user-management/components/UserManagementWorkspaceSwitcherContainer'
import { ManageSkillsDialogContainer } from '@/features/user-management/ManageSkillsDialog/ManageSkillsDialogContainer'
import { WorkspaceInvitationDialogContainer } from '@/features/user-management/WorkspaceInvitationDialog/WorkspaceInvitationDialogContainer'
import { EditUserRoleDialogContainer } from '@/features/user-management/EditUserRoleDialog/EditUserRoleDialogContainer'
import { ManageUserCapacityDialogContainer } from '@/features/user-management/ManageUserCapacityDialog/ManageUserCapacityDialogContainer'
import { RemoveFromWorkspaceDialogContainer } from '@/features/user-management/RemoveFromWorkspaceDialog/RemoveFromWorkspaceDialogContainer'
import { RestoreToWorkspaceDialogContainer } from '@/features/user-management/RestoreToWorkspaceDialog/RestoreToWorkspaceDialogContainer'

export default observer(function UserManagementContainer() {
  const { userManagement, shellInfo } = useFeatures((r) => ({
    userManagement: r.userManagement.internal(),
    shellInfo: r.shell.shellInfo,
  }))
  const vm = userManagement.userManagementViewModel
  useDocumentTitle('User Management')
  const { connectRef: scrollRef, scrollYStart: scrollOffset } =
    useScrollOffsets()
  useActivation(vm)

  return (
    <UserManagement
      canAccessUserManagement={vm.canAccessUserManagement}
      corporateMode={shellInfo.corporateMode}
      scrollRef={scrollRef}
    >
      <UserManagementWorkspaceSwitcherContainer
        scrollOffset={scrollOffset}
        vm={vm}
      />

      {isRefreshDesign ? (
        <UserListContainer vm={vm} />
      ) : (
        <UserManagementTableContainer vm={vm} />
      )}
      <EditUserRoleDialogContainer vm={vm.editUserRoleVm} />
      <ManageUserCapacityDialogContainer vm={vm.manageUserCapacityVm} />
      <WorkspaceInvitationDialogContainer vm={vm.workspaceInvitationVm} />
      <ManageSkillsDialogContainer vm={vm.manageSkillsVm} />
      <RemoveFromWorkspaceDialogContainer vm={vm.removeFromWorkspaceVm} />
      <RestoreToWorkspaceDialogContainer vm={vm.restoreToWorkspaceVm} />
    </UserManagement>
  )
})
